import { isHandedIn } from '../../utils/submissionStatus';

/**
 * Who "Upload responses" can still be used for.
 *
 * The menu exists to get work in for a student who has none, so a student who
 * has already handed in does not belong on it. A teacher-created DRAFT shell is
 * not a hand-in (see isHandedIn), so that student stays listed.
 */

const studentIdOf = (submission) =>
  submission?.studentId ?? submission?.student?.id ?? submission?.userId;

const isUsableId = (id) => id != null && id !== '';

const handedInIds = (submissions) =>
  new Set(
    (submissions ?? [])
      .filter(isHandedIn)
      .map(studentIdOf)
      .filter(isUsableId)
      .map(String),
  );

const studentsInClass = (allClasses) => (classId) =>
  (allClasses ?? []).find((cls) => classId === cls?.id)?.students ?? [];

const assignedStudents = (assignment, allClasses) =>
  (assignment?.classIds ?? []).flatMap(studentsInClass(allClasses));

const toOption = (student) => ({
  id: student.id,
  name: student.name || student.firstName || `Student ${student.id}`,
});

const firstOfEachStudent = (students) => {
  const seen = new Set();
  return students.filter((student) => {
    const key = String(student?.id);
    return seen.has(key) ? false : Boolean(seen.add(key));
  });
};

export const buildUploadCandidates = ({
  assignment,
  allClasses,
  submissions,
}) => {
  const submitted = handedInIds(submissions);
  const roster = firstOfEachStudent(assignedStudents(assignment, allClasses));
  return roster
    .filter((student) => !submitted.has(String(student?.id)))
    .map(toOption);
};

export default buildUploadCandidates;
